import { useNavigate } from "react-router";
import { defineCanGoBack } from "../utils/canGoBack";

export interface UseGoBackReturn {
    goBack: () => void;
    canGoBack: boolean;
}

export default function (path?: string): UseGoBackReturn {
    const navigate = useNavigate();
    const canGoBack = defineCanGoBack();

    function goBack() {
        if (path) navigate(path, { replace: true });
        //Verify not leaving the site
        else if (!canGoBack) navigate("/", { replace: true });
        else navigate(-1);
    }
    return {
        goBack,
        canGoBack,
    };
}
